/**
 * Email + social auth endpoints: verification, password reset, passwordless
 * OTP login, and Google sign-in. Login/register live on the auth store
 * directly; these are the extra flows.
 */
import { api } from '@/api/client';
import type { AuthResponse } from '@/api/types';

// ── email verification ──
export const resendVerification = () =>
  api<{ sent: boolean }>('POST', '/api/auth/verify/send');

export const confirmVerification = (token: string) =>
  api<{ verified: boolean }>('POST', '/api/auth/verify/confirm', { token });

// ── password reset ──
export const forgotPassword = (email: string) =>
  api<{ sent: boolean }>('POST', '/api/auth/password/forgot', { email });

export const resetPassword = (token: string, password: string) =>
  api<{ reset: boolean }>('POST', '/api/auth/password/reset', { token, password });

// ── passwordless OTP login ──
export const requestOtp = (email: string) =>
  api<{ sent: boolean }>('POST', '/api/auth/otp/request', { email });

export const verifyOtp = (email: string, code: string) =>
  api<AuthResponse>('POST', '/api/auth/otp/verify', { email, code });

// ── Google ──
export interface GoogleStartResponse {
  authorizeUrl: string;
  state: string;
}

export const startGoogle = () =>
  api<GoogleStartResponse>('POST', '/api/auth/google/start');

export const completeGoogle = (code: string, state: string) =>
  api<AuthResponse>('POST', '/api/auth/google/callback', { code, state });
